
      // this file is automatically generated by git.version.ts script
      export const versions = {
        version: '0.0.0',
        revision: 'b93bfca',
        branch: 'dev'
      };